const js = {
    "js": [
        {
            "name":"ES5",
            "img": "",
            "thumbnail":"es5.svg",
            "hint": "",
            "link":"http://es5.github.io/spec.html"
        },
        {
            "name":"Angular",
            "img": "",
            "thumbnail":"ang.svg",
            "hint": "",
            "link":"https://angular.io/"
        },
        {
            "name": "React",
            "img": "",
            "thumbnail":"react.svg",
            "hint": "",
            "link":"https://facebook.github.io/react/",
        },
        {
            "name": "Redux",
            "img": "",
            "thumbnail":"redux.svg",
            "hint": "",
            "link":"http://redux.js.org/docs/introduction/",
        },
        {
            "name": "Vue",
            "img": "",
            "thumbnail":"vue.svg",
            "hint": "",
            "link":"https://vuejs.org/"
        },
        
    ],
    "libraries":[
        {
            "name":"jQuery",
            "img": "",
            "thumbnail":"jquery.svg",
            "hint": "",
            "link":"http://api.jquery.com/"
        },
        {
            "name": "Lodash",
            "img": "",
            "thumbnail":"lodash.svg",
            "hint": "",
            "link":"https://lodash.com/docs/4.16.3"
        },
        {
            "name":"Axios",
            "img": "",
            "thumbnail":"axios.svg",
            "hint": "",
            "link":"https://www.npmjs.com/package/axios"
        },
        {
            "name":"jquerymy",
            "img": "",
            "thumbnail":"jquerymy.svg",
            "hint": "",
            "link":"http://jquerymy.com/#/"
        },

    ],

    "animate": [
        {
            "name":"Animate.css",
            "img": "",
            "thumbnail":"404.svg",
            "hint": "",
            "link":"https://daneden.github.io/animate.css/"
        },
        {
            "name":"anime",
            "img": "",
            "thumbnail":"anime.svg",
            "hint": "",
            "link":"http://animejs.com/"
        },
        {
            "name":"minimamente",
            "img": "",
            "thumbnail":"404.svg",
            "hint": "",
            "link":"https://www.minimamente.com/example/magic_animations/"
        },
        {
            "name":"threejs",
            "img": "",
            "thumbnail":"404.svg",
            "hint": "",
            "link":"https://threejs.org/"
        },
        {
            "name":"bouncejs",
            "img": "",
            "thumbnail":"404.svg",
            "hint": "",
            "link":"http://bouncejs.com/"
        },
        {
            "name":"izimodal",
            "img": "",
            "thumbnail":"404.svg",
            "hint": "",
            "link":"http://izimodal.marcelodolce.com/"
        },
        {
            "name":"Izitoast",
            "img": "",
            "thumbnail":"404.svg",
            "hint": "",
            "link":"http://izitoast.marcelodolce.com/"
        },
        {
            "name":"wowJS",
            "img": "",
            "thumbnail":"wow.svg",
            "hint": "",
            "link":"http://mynameismatthieu.com/WOW/"
        },
        {
            "name":"barba",
            "img": "",
            "thumbnail":"barba.svg",
            "hint": "",
            "link":"https://github.com/luruke/barba.js"
        },
        {
            "name":"velocityjs",
            "img": "",
            "thumbnail":"404.svg",
            "hint": "",
            "link":"http://velocityjs.org/"
        },
        {
            "name":"vivus",
            "img": "",
            "thumbnail":"vivus.svg",
            "hint": "",
            "link":"https://github.com/maxwellito/vivus#vivusjs"
        },
        {
             "name":"Animsition",
            "img": "",
            "thumbnail":"animsition.svg",
            "hint": "",
            "link":"http://git.blivesta.com/animsition/"
        },
        {
            "name":"particles",
            "img": "",
            "thumbnail":"particles.svg",
            "hint": "",
            "link":"http://vincentgarreau.com/particles.js/"
        },
        {
            "name":"animate technics",
            "img": "",
            "thumbnail":"at.svg",
            "hint": "",
            "link":"https://uxplanet.org/popular-web-animation-techniques-a6a467309028"
        }
    ],
    "scroll": [
        {
            "name":"fullPage",
            "img": "",
            "thumbnail":"fullPage.svg",
            "hint": "",
            "link":"https://alvarotrigo.com/fullPage/#firstPage"
        },
        {
            "name":"pagePiling",
            "img": "",
            "thumbnail":"multiS.svg",
            "hint": "",
            "link":"https://github.com/alvarotrigo/pagePiling.js"
        },
        {
            "name":"aos",
            "img": "",
            "thumbnail":"aos.svg",
            "hint": "",
            "link":"http://michalsnik.github.io/aos/"
        },
        {
            "name":"page-scroll-to-id",
            "img": "",
            "thumbnail":"pageToScroll.svg",
            "hint": "",
            "link":"https://github.com/malihu/page-scroll-to-id"
        },
        {
            "name":"waypoints",
            "img": "",
            "thumbnail":"waypoints.svg",
            "hint": "",
            "link":"http://imakewebthings.com/waypoints/"
        },
        {
            "name":"onepage-scroll",
            "img": "",
            "thumbnail":"onepage-scroll.svg",
            "hint": "",
            "link":"https://github.com/peachananr/onepage-scroll"
        },
        {
            "name":"jInvertScroll",
            "img": "",
            "thumbnail":"jInvertScroll.svg",
            "hint": "",
            "link":"http://www.pixxelfactory.net/jInvertScroll/"
        },
        {
            "name":"multiscroll",
            "img": "",
            "thumbnail":"multiS.svg",
            "hint": "",
            "link":"https://github.com/alvarotrigo/multiscroll.js"
        },
        {
            "name":"midnight",
            "img": "",
            "thumbnail":"midNight.svg",
            "hint": "",
            "link":"http://aerolab.github.io/midnight.js/"
        },
        {
            "name":"Scrolline",
            "img": "",
            "thumbnail":"scrollLine.svg",
            "hint": "",
            "link":"https://github.com/anthonyly/Scrolline.js"
        }
        
    ],
    "charts": [
        {
            "name":"chartist-js",
            "img": "",
            "thumbnail":"404.svg",
            "hint": "",
            "link":"http://gionkunz.github.io/chartist-js/index.html"
        },
        {
            "name":"chartjs",
            "img": "",
            "thumbnail":"chartjs.svg",
            "hint": "",
            "link":"http://www.chartjs.org/"
        },
    ],
    "drag": [
       {
            "name":"dragdealer",
            "img": "",
            "thumbnail":"404.svg",
            "hint": "",
            "link":"http://skidding.github.io/dragdealer/"
        },
        {
            "name":"Sortable",
            "img": "",
            "thumbnail":"404.svg",
            "hint": "",
            "link":"http://rubaxa.github.io/Sortable/"
        },
    ],
    "for input": [
        {
            "name":"cleave",
            "img": "",
            "thumbnail":"404.svg",
            "hint": "",
            "link":"http://nosir.github.io/cleave.js/"
        },
        {
            "name":"select2",
            "img": "",
            "thumbnail":"select2.svg",
            "hint": "",
            "link":"https://select2.org/"
        },
        {
            "name":"selectize",
            "img": "",
            "thumbnail":"404.svg",
            "hint": "",
            "link":"http://selectize.github.io/selectize.js/"
        },
        {
            "name":"jquery-nice-select",
            "img": "",
            "thumbnail":"404.svg",
            "hint": "",
            "link":"http://hernansartorio.com/jquery-nice-select/"
        },
        {
            "name":"flexdatalist",
            "img": "",
            "thumbnail":"404.svg",
            "hint": "",
            "link":"http://projects.sergiodinislopes.pt/flexdatalist/"
        },
        {
            "name":"typeahead",
            "img": "",
            "thumbnail":"404.svg",
            "hint": "",
            "link":"http://twitter.github.io/typeahead.js/"
        },
    ],

    "plagins": [
        
        {
            "name":"Parallax",
            "img": "",
            "thumbnail":"404.svg",
            "hint": "",
            "link":"http://pixelcog.github.io/parallax.js/"
        },
        {
            "name":"wagerfield-parallax",
            "img": "",
            "thumbnail":"par2.svg",
            "hint": "",
            "link":"https://github.com/wagerfield/parallax"
        },
        {
            "name":"motio",
            "img": "",
            "thumbnail":"404.svg",
            "hint": "",
            "link":"http://darsa.in/motio/#"
        },
        
        {
            "name":"MixItUp",
            "img": "",
            "thumbnail":"404.svg",
            "hint": "",
            "link":"https://mixitup.kunkalabs.com/"
        },
        {
            "name":"typed-js",
            "img": "",
            "thumbnail":"typed.svg",
            "hint": "",
            "link":"http://www.mattboldt.com/demos/typed-js/"
        },
        {
            "name":"instantclick",
            "img": "",
            "thumbnail":"404.svg",
            "hint": "",
            "link":"http://instantclick.io/"
        },
        {
            "name":"keycode",
            "img": "",
            "thumbnail":"404.svg",
            "hint": "",
            "link":"http://keycode.info/"
        },
        {
            "name":"routing",
            "img": "",
            "thumbnail":"smalljs.svg",
            "hint": "",
            "link":"http://smalljs.org/client-side-routing/page/"
        },
        
        {
            "name":"slideout",
            "img": "",
            "thumbnail":"slideOut.svg",
            "hint": "",
            "link":"https://slideout.js.org/"
        },
        
        {
            "name":"tether",
            "img": "",
            "thumbnail":"404.svg",
            "hint": "",
            "link":"http://tether.io/"
        },
        
        {
            "name":"shepherd",
            "img": "",
            "thumbnail":"shepherd.svg",
            "hint": "",
            "link":"https://github.com/HubSpot/shepherd"
        },
        
        {
            "name":"tooltip",
            "img": "",
            "thumbnail":"shepherd.svg",
            "hint": "",
            "link":"https://github.com/HubSpot/tooltip"
        },
        {
            "name":"favico",
            "img": "",
            "thumbnail":"404.svg",
            "hint": "",
            "link":"http://lab.ejci.net/favico.js/"
        },
        {
            "name":"csspin",
            "img": "",
            "thumbnail":"404.svg",
            "hint": "",
            "link":"https://webkul.github.io/csspin/"
        },
        {
            "name":"loaders",
            "img": "",
            "thumbnail":"404.svg",
            "hint": "",
            "link":"https://connoratherton.com/loaders"
        },
       
        
        
        
        
    ],

    "tests":[
        {
            "name":"mocha",
            "img": "",
            "thumbnail":"mocha.svg",
            "hint": "",
            "link": "https://mochajs.org/"
        },
        {
            "name":"karma",
            "img": "",
            "thumbnail":"karma.svg",
            "hint": "",
            "link": "https://karma-runner.github.io/1.0/index.html"
        },
        {
            "name": "Phantome",
            "img": "",
            "thumbnail":"phantom.svg",
            "hint": "",
            "link":"http://phantomjs.org/"
        },
        {
            "name":"Jasmine",
            "img": "",
            "thumbnail":"jasmine.svg",
            "hint": "",
            "link": "https://jasmine.github.io/"
        }
    ]
}

export default js;


// WEBPACK FOOTER //
// ./src/assets/db/js.js